var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"my-4"},[_vm._v(_vm._s(_vm.$t('osce-schedule')))]),_c('DynTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }